(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
// JavaScript for the Announcement Bar Carousel with Swipe functionality
var currentSlide = 0;
var totalSlides = document.querySelectorAll('.announcement-item').length;
var slideContainer = document.getElementById('announcement-items-container');
var startX = 0;
var endX = 0;

// Ensure the DOM is fully loaded before running
document.addEventListener('DOMContentLoaded', function() {
  // Hide the announcement bar if it was closed within the last 48 hours
  if(localStorage.getItem('announcementClosed') && new Date().getTime() < localStorage.getItem('announcementClosed')) {
    document.getElementById('announcement-bar').style.display = 'none';
  } else {
    showSlide(currentSlide);
  }

  // Attach event listeners for arrows
  document.getElementById('arrow-left').addEventListener('click', function() {
    moveSlide('prev');
  });
  document.getElementById('arrow-right').addEventListener('click', function() {
    moveSlide('next');
  });

  // Automatically move the slide every 9 seconds
  setInterval(() => {
    currentSlide++;
    showSlide(currentSlide);
  }, 9000);
});

// Show the current slide by translating the container
function showSlide(index) {
  var slides = document.querySelectorAll('.announcement-item');

  if (index >= totalSlides) {
    currentSlide = 0; // Loop back to the first slide
  }
  if (index < 0) {
    currentSlide = totalSlides - 1; // Loop to the last slide
  }

  // Update the position of the container to show the correct slide
  var offset = -100 * currentSlide; // Move the container by 100% of the slide width
  slideContainer.style.transform = `translateX(${offset}%)`;

  // Hide arrows if there's only one slide
  if (totalSlides === 1) {
    document.getElementById('announcement-bar').classList.add('one-slide');
  } else {
    document.getElementById('announcement-bar').classList.remove('one-slide');
  }
}

function moveSlide(direction) {
  if (direction === 'next') {
    currentSlide++;
  } else if (direction === 'prev') {
    currentSlide--;
  }

  showSlide(currentSlide);
}

// Make closeAnnouncement globally accessible
window.closeAnnouncement = function() {
  document.getElementById('announcement-bar').style.display = 'none';

  // Set localStorage to hide announcement for 48 hours
  var hideUntil = new Date().getTime() + 48 * 60 * 60 * 1000;
  localStorage.setItem('announcementClosed', hideUntil);
}

// Swipe detection (touch and mouse) 
slideContainer.addEventListener('touchstart', handleTouchStart, false);
slideContainer.addEventListener('touchmove', handleTouchMove, false);
slideContainer.addEventListener('touchend', handleTouchEnd, false);
slideContainer.addEventListener('mousedown', handleMouseDown, false);
slideContainer.addEventListener('mousemove', handleMouseMove, false);
slideContainer.addEventListener('mouseup', handleMouseUp, false);
slideContainer.addEventListener('mouseleave', handleMouseUp, false);

function handleTouchStart(e) {
  startX = e.touches[0].clientX;
}

function handleTouchMove(e) {
  endX = e.touches[0].clientX;
}

function handleTouchEnd() {
  if (startX - endX > 50) {
    moveSlide('next'); // Swipe left -> Move to next slide
  } else if (endX - startX > 50) {
    moveSlide('prev'); // Swipe right -> Move to previous slide
  }
}

function handleMouseDown(e) {
  startX = e.clientX;
}

function handleMouseMove(e) {
  if (startX) {
    endX = e.clientX;
  }
}

function handleMouseUp() {
  if (startX - endX > 50) {
    moveSlide('next'); // Swipe left -> Move to next slide
  } else if (endX - startX > 50) {
    moveSlide('prev'); // Swipe right -> Move to previous slide
  }
  startX = null;
  endX = null;
}

  } catch(e) { console.error(e); }
})();
})();
